import styled from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";
import { Button, SimpleChipItem } from "@similarweb/ui-components";

import { TextField } from "app/pages/sales-intelligence/pages/ai-agent/components/TextfField/TextField";

export const StyledChipItem = styled(SimpleChipItem)`
    margin: 0;
    &:hover {
        background-color: ${rgba(colorsPalettes.carbon[500], 0.8)};
    }

    background-color: ${rgba(colorsPalettes.carbon[500], 0.8)};
    & .ChipItemText {
        color: ${colorsPalettes.carbon[0]};
        max-width: 457px;
        line-height: 32px;
    }

    & div[data-automation-icon-name="clear-circle"] svg path {
        fill: ${colorsPalettes.carbon[0]} !important;
    }
`;

export const StyledAddButton = styled(Button)`
    height: 36px !important;
    width: 60px !important;
    min-width: 60px !important;
`;

export const StyledTextField = styled(TextField)`
    width: 200px;
    & .input-container {
        padding-right: 8px;
    }
`;
